/**
 * Layout
 * @module components/Layout
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './Layout.scss';

/** Class representing the component. */
class Layout extends Component {

	/**
	 * The render method
	 */
	render () {
		const { color, children } = this.props;
		const classes = color ? `${style.layout} ${style[color]}` : style.layout;

		return (
			<div className={classes}>
				<div className={style.content}>
					{ children }
				</div>
			</div>
		);
	}
}


/** Prop types **/
Layout.propTypes = {
	color: PropTypes.oneOf(['turquoise', 'white', 'black']),
	children: PropTypes.oneOfType([ PropTypes.node, PropTypes.object, PropTypes.array ])
};


export default Layout;
